import { Tabs, Card, Typography, Row, Col, Image, Space, Tag, Avatar } from 'antd';
import React from 'react';
import InfoRow from '../../InfoRow/InfoRow';
import PlanDetails from '../PlanDetails/PlanDetails';

const { Title } = Typography;
const { TabPane } = Tabs;



const DealershipDetails = ({ dealership }) => {
  
  return (
    <Card>
      <Tabs defaultActiveKey="1" centered>
        {/* Dealership Details */}
        <TabPane tab="Dealership Details" key="1">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}   ><InfoRow
            label="Business Name" value={dealership?.businessName} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="GST Number" value={dealership?.gstNumber} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Entity Type" value={dealership?.entityType} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Category" value={dealership?.businessCategory} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Address" value={`${dealership?.businessAddress?.address} ${dealership?.businessAddress?.street} ${dealership?.businessAddress?.city} ${dealership?.businessAddress?.state}   ${dealership?.businessAddress?.country}  `} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Overview" value={dealership?.businessOverview} /></Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Business Photo Url" />
              <Image
                src={dealership?.businessPhotoUrl}
              />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Logo Photo Url" />
              <Image
                src={dealership?.logoPhotoUrl}
              />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Dealership  Fee" value={dealership?.franchiseFee} />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Royality Percentage" value={dealership?.royaltyPercentage} />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Required Area(sq ft)" value={dealership?.requiredAreaSqFt} />
            </Col>
          
            <Col xs={24} sm={12} ><InfoRow label="ROI" value={dealership?.expectedROI} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Loan Assistance Options" value={dealership?.loanAssistanceOptions} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Support Provided" value={dealership?.supportProvided} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Territory Availability" value={dealership?.territoryAvailability} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Investment" value={`${dealership?.minimumInvestmentRequired} - ${dealership?.maximumInvestmentRequired}`} /></Col>



            {dealership?.status ===
              'accepted' ? <div>
                <div>
                  <Tag>
                    <span style={{ color: 'green' }}>Accepted</span>
                  </Tag>
                </div>

                <Col xs={24} sm={12} ><InfoRow label="Start Date" value={dealership?.start_date} /></Col>
                <Col xs={24} sm={12} ><InfoRow label="End Date" value={dealership?.end_date} /></Col>
                

            </div>
              : <div>
                
                <title>Status</title>
                <Tag color={'red'}>
                  {dealership?.status === 'pending' ? 'Pending' : 'Rejected'}
                </Tag>
              </div>             
}
          </Row>
         
          <Space>
            <Title level={5}>Payment Status:</Title>
            <Tag color={dealership?.payment_status === 'paid' ? 'green' : 'red'}>
              {dealership?.payment_status === 'paid' ? 'Paid' : 'Not Paid'}
            </Tag>
          </Space>
        </TabPane>

        {/* User Details */}
        <TabPane tab="User Details" key="2">
          <Row gutter={[16, 16]}>
            <Col
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: "center",
                alignItems :"center"
              }}
              
              xs={24}>
              <Avatar
                
                size={123}
                src={dealership?.user?.profilePic}
              />
            </Col>
            <Col xs={24} sm={12}><InfoRow label="Name" value={dealership?.user?.name} /></Col>
            <Col xs={24} sm={12}><InfoRow label="Email" value={dealership?.user?.email} /></Col>
            <Col xs={24} sm={12}><InfoRow label="Phone" value={dealership?.user?.phoneNumber} /></Col>
          </Row>
        </TabPane>

        {/* Plan Details */}
        <TabPane tab="Plan Details" key="3">
          <PlanDetails
          plan={dealership?.plan}
          />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default DealershipDetails;